import SocialHub from "./SocialHub";

export default function App() {
  return <SocialHub />;
}
